module.exports = __webpack_public_path__ + "img/color_block_1.b246f243.svg";